export enum OverlayType {
    'NONE',
    'OVERLAY',
    'BUILDING_TYPOLOGY',
    'INTERNAL_OVERLAY',
    'INFORMATIONAL_OVERLAY'
}

export const overlayTypologyType = [
    'None',
    'Overlay',
    'Building Typology',
    'Internal Overlay',
    'Informational Overlay'
]
